import { useRef, useState } from "react";
import { Play } from "lucide-react";
import { Reveal } from "../motion/Reveal";

export const CompanyVideo = () => {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const start = () => {
    setPlaying(true);
    requestAnimationFrame(() => videoRef.current?.play());
  };

  return (
    <section className="bg-nx-navy2 border-y border-white/10 py-20 sm:py-28" data-testid="home-video-section">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "VideoObject",
            name: "NexSecure Technologies | CCTV, IT & Automation Partner in Kochi, Ernakulam, Kerala",
            description:
              "NexSecure Technologies is Kerala's trusted technology infrastructure partner in Ernakulam (Kochi): CCTV & security systems, IT & network infrastructure, custom software, cloud, smart automation, communication & AV, power backup and AMC managed services.",
            thumbnailUrl: ["https://nexsecure.in/videos/youtube/thumbnail.jpg"],
            uploadDate: "2026-08-25T00:00:00+05:30",
            duration: "PT1M40S",
            contentUrl: "https://nexsecure.in/videos/nexsecure-company-video.mp4",
            embedUrl: "https://www.youtube.com/embed/1MqRka6rp7w",
            publisher: {
              "@type": "Organization",
              name: "NexSecure Technologies",
              logo: { "@type": "ImageObject", url: "https://nexsecure.in/assets/logo-full-dark.svg" },
            },
          }),
        }}
      />
      <div className="nx-wrap">
        <Reveal>
          <div className="max-w-2xl mb-12">
            <p className="text-[10px] tracking-[0.28em] uppercase text-nx-goldlight mb-4">Who We Are</p>
            <h2 className="font-marcellus text-3xl sm:text-4xl text-white leading-snug">
              One partner for everything your business runs on.
            </h2>
            <p className="mt-4 text-sm md:text-base text-slate-400 leading-relaxed">
              Ninety seconds on what we do — software, cloud, networks, security, automation, communication and power — engineered as one system, supported for life.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="relative aspect-video overflow-hidden border border-white/10 bg-black group" data-testid="company-video-frame">
            <video
              ref={videoRef}
              className="w-full h-full object-cover"
              poster="/videos/company-video-poster.jpg"
              controls={playing}
              preload="metadata"
              playsInline
              onEnded={() => setPlaying(false)}
              data-testid="company-video-player"
            >
              <source src="/videos/nexsecure-company-video.mp4" type="video/mp4" />
            </video>
            {!playing && (
              <button
                onClick={start}
                className="absolute inset-0 flex flex-col items-center justify-center gap-5 bg-nx-navy/30 hover:bg-nx-navy/10 transition-colors duration-300"
                aria-label="Play company video"
                data-testid="company-video-play"
              >
                <span className="flex items-center justify-center w-20 h-20 rounded-full bg-nx-gold text-nx-navy shadow-[0_0_60px_rgb(var(--nx-gold)/0.45)] transition-transform duration-300 group-hover:scale-110">
                  <Play size={30} className="ml-1" fill="currentColor" />
                </span>
              </button>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
